import styled, { css } from 'styled-components';

const DEFAULT_WIDTH = '122px';

const rangeSelectorStyles = css`
    border: 3px solid transparent;
    width: 18px;
    height: 18px;
    background: ${props => props.theme.root.colors.primary.default};
    border-radius: 50%;
    transition: all 0.3s ease;
    position: relative;
    z-index: 3;

    &:hover {
        background: ${props => props.theme.root.colors.primary.hover};
    }
`;

export const Input = styled.input<{ width?: string; disabled?: boolean; tickMarksWithoutBg?: boolean }>`
    width: ${props => props.width || DEFAULT_WIDTH};
    position: relative;
    top: 0;
    left: 0;
    -webkit-appearance: none;
    appearance: none;
    cursor: pointer;
    height: 4px;
    background: transparent;
    border-radius: 2px;
    outline: none;
    margin: 0;
    background: ${props => (props.tickMarksWithoutBg ? '' : props.theme.root.colors.basicColors['30%'])};

    &[type='range'] {
        // ff styles
        &::-moz-range-thumb {
            ${rangeSelectorStyles}
        }

        // chrome styles
        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            ${rangeSelectorStyles}
        }
    }

    ${props =>
        props.disabled &&
        css`
            cursor: default;
            background: ${props => props.theme.slider.track.disabled.background};

            &[type='range'] {
                &::-webkit-slider-thumb {
                    background: ${props => props.theme.slider.indicator.disabled.background};

                    &:hover {
                        box-shadow: none;
                    }

                    &:active {
                        box-shadow: none;
                    }
                }
            }
        `}
`;

export const SliderLine = styled.div`
    flex: 1 1 auto;
    margin: auto 0;
    height: 0;
    border-top: 1px solid ${props => props.theme.root.colors.basicColors['15%']};
    border-bottom: 1px solid ${props => props.theme.root.colors.basicColors['15%']};
    border-radius: 2px;
    z-index: 2;
`;
export const ProgressIndicator = styled.span<{ percentage: number; disabled?: boolean }>`
    position: absolute;
    top: 0;
    left: 10px;
    width: ${props => props.percentage}%;
    height: 4px;
    background: ${props => props.theme.slider.indicator.default.background};
    border-radius: 2px;
    z-index: 2;
    ${props =>
        props.disabled &&
        css`
            background: ${props => props.theme.slider.track.disabled.background};
        `}
`;
export const Wrapper = styled.span<{ margin?: string; width?: string; showLabel?: boolean }>`
    position: relative;
    display: block;
    font-size: 0;
    margin: ${props => props.margin || 0};
    width: ${props => props.width || DEFAULT_WIDTH};
    margin-top: ${props => (props.showLabel ? '40px' : '')};
`;

export const Content = styled.span`
    display: contents;
`;

export const StepElementWrapper = styled.div`
    position: relative;
    pointer-events: none;
    flex: 0 0 auto;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: transparent;
`;

export const Step = styled.div<{ isActive: boolean }>`
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    border: 2px solid ${props => props.theme.root.colors.basicColors['15%']};
    border-radius: 50%;

    &:hover {
        border-color: ${props => props.theme.root.colors.basicColors['30%']};
    }
`;

export const StepWrapper = styled.span`
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin: -13px -3px 0;
`;

const marginHelper = (from: number, to: number, percentage: number) => {
    const delta = to - from;
    const step = delta / 100;
    const margin = step * percentage;

    return from + margin;
};

export const El = styled.span``;

export const Label = styled.span<{ percentage: number }>`
    position: absolute;
    top: 23px;
    left: ${props => props.percentage}%;
    margin-left: ${props => marginHelper(8, -8, props.percentage)}px;
    transform: translate(-50%, 0);
    border-radius: 8px;
    padding: 6px 8px;
    color: ${props => props.theme.root.colors.basicColors['90%']};
    background: ${props => props.theme.root.colors.basicColors.inverted['90%']};
    transition: left 0.1s;
`;

export const Description = styled.span<{ isActive?: boolean }>`
    position: absolute;
    top: 23px;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
`;
